<mat-card>
  <mat-card-content class="p-0">
    <app-datatable
      [configurationInput]="datatableConfigurations"
      [rowData]="store.data$()"
      [columns]="datatableColumns"
      [total]="store.dataTotal$()"
      [customColumnDef]="[
        { name: 'providerType', template: providerTypeCell, isSortable: true },
        { name: 'isActive', template: isActiveCell, isSortable: true },
      ]"
      (deleteClick)="selectedDatatableItems().length >= 2 ? initializeBulkDelete() : initializeDelete()"
      (editClick)="initializeEdit()"
      (addClick)="initializeAdd()"
      (dataRefreshRequest)="datatableParams$.next($event)"
      (selectedItemsChange)="selectedDatatableItems.set($event)"
    />
  </mat-card-content>
</mat-card>

<ng-template #providerTypeCell let-row="row">
  {{ 'page.artificialIntelligence.providerTypes.' + row.providerType | translate }}
</ng-template>

<ng-template #isActiveCell let-row="row">
  <mat-chip [ngClass]="row.isActive ? 'green' : 'red'">
    {{ (row.isActive ? 'button.active' : 'button.inactive') | translate | uppercase }}
  </mat-chip>
</ng-template>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()" #form="ngForm">
    <div mat-dialog-content>
      <div class="row">
        <app-callout
          class="col-12 mb-3"
          variant="info"
          icon="verified_user"
          [title]="'page.artificialIntelligence.dataSharingTitle' | translate"
          [description]="'page.artificialIntelligence.dataSharingDescription' | translate"
        ></app-callout>
        <div class="col-12 mb-3">
          <span class="dialog-section"
            ><mat-icon>description</mat-icon> {{ 'system.dialogSection.generalInformation' | translate }}</span
          >
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.controls.name"></mat-error>
        </mat-form-field>
        <mat-dropdown
          class="col-12 mb-3"
          [options]="providerTypeOptions"
          [configurationInput]="{
            singleSelection: true,
            hasMatError: true,
            text: 'field.providerType' | translate,
            repositionDropdownList: true,
          }"
          [formControl]="addEditForm.controls.providerType"
          [isFormSubmitted]="form.submitted"
        ></mat-dropdown>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.instructions' | translate }}</mat-label>
          <textarea matInput rows="4" formControlName="instructions"></textarea>
          <mat-hint>{{ 'page.artificialIntelligence.providerInstructionsHint' | translate }}</mat-hint>
          <mat-error [control]="addEditForm.controls.instructions"></mat-error>
        </mat-form-field>
        <div class="col-12 mt-2">
          <mat-checkbox formControlName="isActive">
            {{ 'field.active' | translate }}
          </mat-checkbox>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 mb-3">
          <span class="dialog-section"
            ><mat-icon>key</mat-icon> {{ 'system.dialogSection.credentials' | translate }}</span
          >
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.apiKey' | translate }}</mat-label>
          <input matInput type="password" autocomplete="new-password" formControlName="apiKey" />
          <mat-hint *ngIf="isEditDialog()">{{
            'page.artificialIntelligence.keepCurrentValueHint' | translate
          }}</mat-hint>
          <mat-error [control]="addEditForm.controls.apiKey"></mat-error>
        </mat-form-field>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
